/**
 * 盘点-盈亏枚举
 */

//盈亏类型(1-盘盈，2-盘亏)
export enum InventoryType {
    /**
     * 盘盈
     */
    PROFIT = 1,
    /**
     * 盘亏
     */
    LOSS = 2,
}
export enum InventoryTypeName {
    PROFIT = '盘盈',
    LOSS = '盘亏',
}

//单据类型（1-盘点盈亏，2-手动盈亏）
export enum BillType {
    /**
     * 盘点盈亏
     */
    INVENTORY = 1,
    /**
     * 手动盈亏
     */
    MANUAL = 2,
}
export enum BillTypeName {
    INVENTORY = '盘点盈亏',
    MANUAL = '手动盈亏',
}

// 提交状态（1-待执行，2-执行完成）
export enum AuditStatus {
    /**
     * 待执行
     */
    PENDING = 1,
    /**
     * 执行完成
     */
    COMPLETED = 2,
}
export enum AuditStatusName {
    PENDING = '待执行',
    COMPLETED = '执行完成',
}

